import { render, staticRenderFns } from "./HeyGovSync.vue?vue&type=template&id=4773c771&"
import script from "./HeyGovSync.vue?vue&type=script&lang=js&"
export * from "./HeyGovSync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports